import { Component, Output, EventEmitter, Input, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setFilterIndex, setOrderDetails, showOrderDetails } from 'src/app/redux/actions/order.action';
import { areas } from '@shared-logic/user';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order, orderOriginConst } from '@shared-logic/orders';
import { ViewOrder } from 'src/app/shared/interfaces/views.interface';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DateChecker } from '@shared-logic/utils';
import { FilterOrderByCommoditiesPipe } from 'src/app/shared/pipes/filter/filterByBuyerType.pipe';
import { FilterByOrderPipe } from 'src/app/shared/pipes/filter/filter.by.order.pipe';
import { FilterOrderWithStringPipe } from 'src/app/shared/pipes/filter/filterWithString.pipe';
import { OrderValidator } from 'src/app/shared/order';
import { User } from '@shared-logic/user/user.interface';
import { Subscription } from 'rxjs';
import { conditionType, setViewMobile } from 'src/app/shared/const/options';
import { OrderBoard, OrderString } from 'src/app/shared/interfaces/order.interface';

@Component({
  selector: 'eraser-table',
  templateUrl: './eraser-table.component.html',
  styleUrls: ['./eraser-table.component.scss']
})
export class EraserTableComponent implements OnInit, OnDestroy {
  user!: User;
  @Input() reload: boolean = false;
  //Array of products
  orders: Order[] = [];
  orderBoard!: OrderBoard;
  isComercial: boolean = true;
  isViewMobile = true;

  //Other filter of tabla
  orderFilter!: OrderString;
  buyerType!: string;
  conditionTypes = conditionType;
  conditionTypeSelected!: string;
  conditionFilters: number[] = [];
  search: string = '';

  //Arrays
  STATUS: any = [];
  BUSINESS_TYPE: any = [];
  PLACE_OF_DELIVERY: any = [];
  QUALITY: any = [];
  TYPE_COIN: any = [];
  WAY_PAY: any = [];
  BONIFICATION: any = [];
  PRODUCTS: any = [];
  OBSERVATIONS: any = [];
  HARVEST: any = [];
  SELLERS: any = [];
  TABLES: any = [];

  ORDER_ORIGIN_CONST: any = orderOriginConst;


  //The column selected to apply a filter
  filterIdentificator: number = -1;
  optionIdentificator: number = -1;

  //The columns that will be seen in the table
  viewSelected!: ViewOrder;

  // isCheckedAll is now a getter, removed property
  ordersSelected: Order[] = [];
  isOrderReturned: boolean = false;

  public wasInside: boolean = false; //Inside in menu option;


  private filter$!: Subscription;
  private buyer$!: Subscription;
  private identificator$!: Subscription;
  private conditionType$!: Subscription;
  private search$!: Subscription;
  private viewSelected$!: Subscription;
  private conditionFilters$!: Subscription;
  private sizeView$!: Subscription;
  private options$!: Subscription;
  private user$!: Subscription;
  constructor(public store: Store<appState>, public router: Router, public dialog: MatDialog, public date: DateChecker, public orderV: OrderValidator) {
    this.rememberEraserOrdersOfLocalStorage();
  }

  ngOnInit(): void {
    this.viewSelected$ = this.store.select('order', 'viewsOfOrderBoard', 'viewSelected').subscribe(viewSelected => {
      this.viewSelected = this.editViewSelected(viewSelected)
    });

    this.filter$ = this.store.select('order', 'orderBoard', 'filter').subscribe(filter => {
      this.orderFilter = filter;
    })

    this.buyer$ = this.store.select('order', 'orderBoard', 'buyerType').subscribe(buyerType => {
      this.buyerType = buyerType;
    })

    this.identificator$ = this.store.select('order', 'orderBoard', 'indexFilter').subscribe(indexFilter => {
      this.filterIdentificator = indexFilter;
    })

    this.conditionType$ = this.store.select('options', 'board', 'conditionTypeSelected').subscribe(conditionType => {
      this.conditionTypeSelected = conditionType;
    })

    this.sizeView$ = this.store.select('options', 'sizeView').subscribe(sizeView => {
      this.isViewMobile = setViewMobile(sizeView);
    })

    this.user$ = this.store.select('usuario').subscribe(state => {
      this.user = state;
      this.isComercial = state.area == areas.comercial;
    })

    this.search$ = this.store.select('options', 'board', 'search').subscribe(search => {
      this.search = search;
    });

    this.conditionFilters$ = this.store.select('options', 'board', 'conditionFilter').subscribe((conditionFilters) => {
      this.conditionFilters = conditionFilters;
    })
  }

  // Let's just add logs first as requested.
  // The user says "2nd time it fails". 
  // 1st time: reload false -> true. if (this.reload) runs.
  // 2nd time: reload true -> false. if (this.reload) is false. DOES NOT RUN.

  // I will add the logs to CONFIRM this, as requested. I won't fix it yet to allow verification.
  ngOnChanges(changes: SimpleChanges) {
    if (changes["reload"]) {
      this.ordersSelected = []; // Clear selection on reload
      this.handleReloadChange();
    }
  }

  private handleReloadChange() {
    // Always execute update because reload is a toggle mechanism
    this.rememberEraserOrdersOfLocalStorage();
  }

  rememberEraserOrdersOfLocalStorage() {
    this.orders = [...this.orderV.getEraserOrders()];
  }

  /* ... other methods ... */

  // Stub for child components to override
  selectAction(event: any) { }

  selectOrder(order: Order) {
    if (order._id) {
      const positionInOrderList = this.orderV.indexOfOrder(this.ordersSelected, order);
      const ordersSelectedAux = JSON.parse(JSON.stringify(this.ordersSelected));
      //Si el elemento no está, lo añadimos. Si está, lo eliminamos.
      positionInOrderList < 0 ? ordersSelectedAux.push(order) : ordersSelectedAux.splice(positionInOrderList, 1);
      this.ordersSelected = ordersSelectedAux;
      // Note: We don't use store for eraser selection to keep it simple as requested, or if we do, adhere to pattern. 
      // User said "No es necesario utilizar NgRx Store". So local state is fine.
    }
  }

  isOrderSelected(order: Order): boolean {
    return this.orderV.indexOfOrder(this.ordersSelected, order) !== -1;
  }

  selectAll() {
    if (this.ordersSelected.length === this.orders.length) {
      this.ordersSelected = [];
    } else {
      this.ordersSelected = [...this.orders];
    }
  }

  get isCheckedAll() {
    return this.orders.length > 0 && this.ordersSelected.length === this.orders.length;
  }

  ngOnDestroy(): void {
    this.filter$?.unsubscribe();
    this.buyer$?.unsubscribe();
    this.identificator$?.unsubscribe();
    this.conditionType$?.unsubscribe();
    this.sizeView$?.unsubscribe();
    this.options$?.unsubscribe();
    this.user$?.unsubscribe();
    this.search$?.unsubscribe();
    this.viewSelected$?.unsubscribe();
    this.conditionFilters$?.unsubscribe();
  }

  //It is a different function for business users and operators.
  selectFilter(index: number) {
    this.store.dispatch(setFilterIndex({ index: index == this.filterIdentificator ? -1 : index }));
  }

  closeAllFilters() {
    this.store.dispatch(setFilterIndex({ index: -1 }));
  }

  getIsNew(order: Order): boolean {
    return order.dataOfcreation.hour == this.date.getHour();
  }

  showOrderDetail(order: Order) {
    this.store.dispatch(setOrderDetails({ order: order }));
    this.store.dispatch(showOrderDetails({ show: true }));
  }

  //-----------------------------------------------\\
  editViewSelected(firstViewSelected: ViewOrder): ViewOrder {
    let copyView: ViewOrder = JSON.parse(JSON.stringify(firstViewSelected));
    copyView.orderStatus = false;
    copyView.contractNumber = false;
    copyView.buyer = false;
    return copyView;
  }

  getOrderListWithPipes() {
    let newPricesList = JSON.parse(JSON.stringify(this.orders));
    const pipe1 = new FilterOrderByCommoditiesPipe();
    const pipe2 = new FilterByOrderPipe();
    const pipe3 = new FilterOrderWithStringPipe();
    return pipe3.transform(pipe2.transform(pipe1.transform(newPricesList, this.buyerType), this.orderFilter), this.search)
  }

  @Output() actionEraser = new EventEmitter<any>(); //Emit to parent component
  deleteOrder(order: Order) {
    const respon: any = {
      showModal: true,
      title: "¿Está seguro que desea eliminar la orden?",
      action: 'delete',
      order: order
    }
    this.actionEraser.emit(respon); //Emite la respuesta
  }

  sendOrder(order: Order) {
    // Check if we have multiple selected. If so, ignore the specific 'order' param (or check if it's in selection)
    // Actually, usually 'sendOrder' is called from a specific row button. 
    // But if we want bulk action, we might have a button outside or use the individual row button to trigger bulk if selected?
    // User requirement: "Cuando enviamos, se deben deseleccionar."

    // If the passed order is part of selection and selection > 1, send all selected.
    // If passed order is NOT selected (clicked on unselected row action), send just that one? 
    // Or simpler: If selection > 0, always send selection (and confirm).

    const isBulk = this.ordersSelected.length > 0;
    const ordersToSend = isBulk ? this.ordersSelected : [order];
    const title = isBulk
      ? `¿Está seguro que desea enviar las ${ordersToSend.length} ordenes al operador?`
      : "¿Está seguro que desea enviar la orden al operador?";

    const respon: any = {
      showModal: true,
      title: title,
      action: 'send',
      order: order, // Keep for backward compat or reference
      orders: ordersToSend
    }
    this.actionEraser.emit(respon);

    // We should clear selection AFTER action is confirmed/done, but here we just emit.
    // The parent handles the action. We can clear selection here or let parent trigger reload which clears it?
    // The parent calls `refresh()` which toggles `reload` input.
    // We should implement `ngOnChanges` to clear selection on reload.
  }

  emitAction(event: any) {
    this.actionEraser.emit(event);
  }
}